import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from './auth_store';

export const forms = defineStore('forms', {
  state: () => ({ // data
    hashSettings: {},
  }),
  actions: {
    allSettings (params = {}) {
      const uid = JSON.stringify(params);
      if (this.hashSettings[uid]) return this.hashSettings[uid];
      this.hashSettings[uid] = axios.get('/forms/settings', { params })
          .then(r => r.data || {});
      return this.hashSettings[uid];
    },
    settings (uid) {
      if (this.hashSettings[uid]) return this.hashSettings[uid];
      const url = `/forms/${uid}/settings`;
      // if (useAuthStore().isPublic) url = `${window.location.pathname}/form_settings`; // /pub/form/0COydz6l9kyS5Nzn/form_settings
      if (useAuthStore().isPublic) return this.hashSettings[uid] = Promise.resolve({});

      this.hashSettings[uid] = axios.get(url)
          .then(r => r.data || {});
      return this.hashSettings[uid];
    },
    loadSettingsToOptions (toForm) {
      return this.settings(toForm.uid).then( data => {
        // eslint-disable-next-line fp/no-mutation
        toForm.options = { ...toForm.options, ...data };
        return toForm;
      });
    },
  },
});